export default __webpack_public_path__ + "static/media/re-weaving-indias-success-story-1626x696.4208a405.jpg";